let Genesis = require("../Genesis.js");
let PDFJS = require('pdfjs-dist/build/pdf.js');
let PDFWorker = require('pdfjs-dist/build/pdf.worker.js');
export  class DocumentPreview {
// in order to limit performance hit
    // when rendering very large pdf files
    // decision was made to present document's first three pages
    // PDFJS doesn't limit pages count in any way
    private pdfPagesCount = 3;
   
    constructor(private previewContainerSelector: string) {

    }
    public openPdf(documentUrl:string, disablePagesLimit:number) {
   // Genesis.Utilities.Messages.block(this._previewContainerSelector);
    
        PDFJS.workerSrc = PDFWorker;
    
    PDFJS.getDocument(documentUrl)
        .then ((pdfDoc:any) => {
            const pagesLimit = disablePagesLimit ? pdfDoc.numPages : this.pdfPagesCount;
            for (let num = 1; num <= pagesLimit; num++) {
                pdfDoc.getPage(num).then(this._appendPage);
            }
        })
        .catch(function () {
           // Genesis.Utilities.Messages.error(Common.Texts.Alert_Failure_Title, Common.Texts.Server_Error_Message);
        })
        .then(function () {
          //  Genesis.Utilities.Messages.unblock(_previewContainerSelector);
        });
    };

    public openImage(imgUrl:string) {
        //Genesis.Utilities.Messages.block(_previewContainerSelector);

        const img = document.createElement('img');
        img.onload = () => {/* Genesis.Utilities.Messages.unblock(this._previewContainerSelector);*/ };
        img.src = imgUrl;
        img.className = "img-fluid img-thumbnail";
        const placeHolder = document.querySelector(this.previewContainerSelector);
        if (placeHolder !== null) {
            placeHolder.appendChild(img);
        }
    };


    private _appendPage(page:any) {
        const viewport = page.getViewport(1.5);
        const canvas = document.createElement('canvas');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const placeHolder = document.querySelector(this.previewContainerSelector);
        if (placeHolder !== null) {
            placeHolder.appendChild(canvas);
        }

        page.render({
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
        });
    };
}